// src/contexts/PartnerAdminContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { getPartnerMe } from "@/services/partnerAdminService";

const PartnerAdminContext = createContext(null);

export const PartnerAdminProvider = ({ children }) => {
  const [membership, setMembership] = useState(undefined);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getPartnerMe();
        setMembership(data.membership);
      } catch (err) {
        setError(err);
        setMembership(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <PartnerAdminContext.Provider value={{ membership, loading, error }}>
      {children}
    </PartnerAdminContext.Provider>
  );
};

export const usePartnerAdmin = () => useContext(PartnerAdminContext);